import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface UnderlyingMapStore {
  map?: { [key: string]: string };
  setMap: (map?: { [key: string]: string }) => void;
}

export const useUnderlyingMapStore = create<UnderlyingMapStore>()(
  devtools((set) => ({
    map: {
      SPXW: 'SPX',
    },
    setMap: (map) => {
      return set({
        map: {
          ...map,
          SPXW: 'SPX',
        },
      });
    },
  }))
);
